export default {"src":"/_next/static/media/Bg_Shapes.d9ffb6ea.svg","height":920,"width":1324,"blurWidth":0,"blurHeight":0};